<div *ngIf="game != null" (click)="openDetails($event)" [attr.aria-role]="isSingleCard ? '' : 'listitem'" [attr.aria-describedby]="isSingleCard ? 'game-title-' + game.code + ' game-description-' + game.code : ''">
   <div role="region">
    <div class="game-image">
        <div class="game-icon">
            <picture>
                <source media="(min-width: {{md}})" srcset="{{getIconImageUrl(game.code,'desktop')}}">
                <source media="(min-width: {{sm}})" srcset="{{getIconImageUrl(game.code,'tablet')}}">
                <img loading="lazy" role="presentation" class="gameCard-icon" src="{{getIconImageUrl(game.code, 'mobile')}}" alt=""/>
            </picture>
        </div>
        <div *ngIf="!isSingleCard && !optinEnhancements" class="game-status title-xxs"  [attr.aria-label]="game.name +' is in '+ game.gameStatus + ' status'"
            [ngClass]="{'in-progress' : game.gameStatus === GAMESTATUS[1], 'not-started' : game.gameStatus !== GAMESTATUS[1] }">
            <div aria-hidden="true">{{game.gameStatus}}</div>
        </div>
        <div *ngIf="!isSingleCard && optinEnhancements" class="game-status title-xxs"  [attr.aria-label]="game.name +' is in '+ game.gameStatus + ' status'"
            [ngClass]="{'not-ended' : game.gameStatus !== GAMESTATUS[2], 'ended' : game.gameStatus == GAMESTATUS[2] }">
            <div aria-hidden="true">{{gameEndStatus}} </div>

        </div>
    </div>
    <div *ngIf="isSingleCard">
        <div class="sr-only">{{game.name}} Ends on {{ shortDate(game.endDateString) }}</div>
        <div role="presentation" role="text" aria-hidden="true" class="game-expiration body-text-xs pl-3 pr-4">Ends: {{ shortDate(game.endDateString) }}</div>
    </div>
    
    <div class="game-details" [attr.aria-labeledby]="'game-title-' + game.code">
        <div class="game-left-box">
            <div [id]="'game-title-' + game.code" role="heading" aria-level="3" [attr.aria-label]="game.name" class="game-title title-sm-bold pl-3 pr-4 pb-1">{{game.name}} </div>
            <div [id]="'game-description-' + game.code" class="game-description body-text pl-3 pr-4"><span>{{game.description}}</span>
                <ng-container *ngIf="isSingleCard">
                    
                    <a href="javascript:void(0)" #howItWorksLink id="how-it-works-link" (click)="showHowItWorks()" class="ml-2 links__action links__action__inline underline">How it Works</a>
                    
                    <span class="pl-1 pr-1">|</span>
                    <a href="{{programRulesLink}}" target="_blank" aria-label="Official Rules link opens in a new tab" class="links__action links__action__inline underline">Official Rules</a>
                    <ng-container *ngIf="game.type == GAMETYPES.EPISODIC">
                        <span class="pl-1 pr-1">|</span>
                        <a href="{{programFAQLink}}" target="_blank" aria-label="FAQ link opens in a new tab" class="links__action links__action__inline underline">FAQ</a>
                    </ng-container>


                </ng-container>
            </div>
            <div *ngIf="!isSingleCard" class="sr-only" aria-hidden="true">Ends on {{ shortDate(game.endDateString) }}</div>
            <div *ngIf="!isSingleCard" role="text" class="game-expiration body-text-xs pl-3 pr-4">Ends: {{ shortDate(game.endDateString) }}</div>
        </div>

        <div class="game-right-box" [ngClass]="{ episodic: game.type == GAMETYPES.EPISODIC }">
            <div class="game-scoreboard" >
                <div *ngIf="game.type == GAMETYPES.EPISODIC; then episodicScoreCard else divisionScoreCard"></div>

                <ng-template #episodicScoreCard>
                    <div class="score" role="text" [attr.aria-label]="'Sweepstakes Entries ' + game.sweepstakesEntries">
                        <div class="sweepstakes">
                            <div aria-hidden="true" class="value title-xl">{{game.sweepstakesEntries}}</div>
                            <span *ngIf="isSingleCard" id="infoButton" tabindex="0" type="button" [tooltip]="sweepstakesEntriesInfo" aria-label="Tooltip" role="button" placement="top" closeOnEsc triggers="click">
                                <span class="svg-icon svg-info-outline icon-tooltip"></span>
                            </span>
                        </div>
                        <div aria-hidden="true" class="label title-xxs">Sweepstakes entries</div>
                    </div>
                    <div class="divider"></div>
                    <div class="score" role="text" [attr.aria-label]="'Game plays available '+ game.totalPrizesWon">
                        <div aria-hidden="true" class="value title-xl">{{game.totalGamePoints}}</div>
                        <div aria-hidden="true" class="label title-xxs">Gameplays available</div>
                    </div>
                    <div *ngIf="isSingleCard" class="divider"></div>
                    <div *ngIf="isSingleCard" class="score" role="text" [attr.aria-label]="'Game plays used '+ game.gameplaysUsed">
                        <div aria-hidden="true" class="value title-xl">{{game.gameplaysUsed}}</div>
                        <div aria-hidden="true" class="label title-xxs">Gameplays used</div>
                    </div>
                </ng-template>
    
                <ng-template #divisionScoreCard>
                    <div class="score" role="text" [attr.aria-label]="getTokenLabel(game.totalGamePoints) + ' earned ' + game.totalGamePoints">
                        <div aria-hidden="true" class="value title-xl">{{game.totalGamePoints}}</div>
                        <div aria-hidden="true" class="label title-xxs">{{getTokenLabel(game.totalGamePoints)}}</div>
                    </div>
                    <div class="divider"></div>
                    <div class="score" role="text" [attr.aria-label]="'Redemptions on game '+ game.totalPrizesWon">
                        <div aria-hidden="true" class="value title-xl">{{game.totalPrizesWon}}</div>
                        <div aria-hidden="true" class="label title-xxs">Redemptions</div>
                    </div>
                </ng-template>
            </div>
            
            <ng-container *ngIf="!isSingleCard && !optinEnhancements">
                <ng-container *ngIf="validStore && game.gameStatus === GAMESTATUS[1]">
                    <div class="game-status-options bold-font-weight">
                        <span tabindex="0" role="link" #gameStatus (keyup.enter)="openDetails($event)" class="link-reg game-status-text" [attr.aria-label]="'Resume Playing ' + game.name ">Resume Playing</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="validStore && game.gameStatus === GAMESTATUS[0]">
                    <div class="game-status-options bold-font-weight">
                        <span tabindex="0" role="link" class="link-reg game-status-text" #gameStatus (keyup.enter)="openDetails($event)"  [attr.aria-label]="'Start Playing ' + game.name ">Start Playing</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="!validStore && game.gameStatus === GAMESTATUS[1]">
                    <div class="game-status-options bold-font-weight">
                        <span tabindex="0" role="link" class="link-reg game-status-text" #gameStatus (keyup.enter)="openDetails($event)"  [attr.aria-label]="'Change Stores to keep playing ' + game.name ">Change Stores to keep playing</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="game.gameStatus === GAMESTATUS[2]">
                    <div class="game-status-options bold-font-weight">
                        <span tabindex="0" role="link" class="link-reg game-status-text" #gameStatus (keyup.enter)="openDetails($event)"  [attr.aria-label]="'Game Summary for ' + game.name " >Game Summary</span>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!isSingleCard && optinEnhancements">
                <ng-container *ngIf="validStore && (game.gameStatus === GAMESTATUS[1] || game.gameStatus === GAMESTATUS[0])">
                    <div class="game-status-options bold-font-weight">
                        <button role="link" #gameStatus (keyup.enter)="openDetails($event)" class="btn btn-xl btn-primary game-status-text" [attr.aria-label]="'Shop and Redeem ' + game.name ">Shop and Redeem</button>
                        <p class="pt-3" [style.visibility]="displayNumberOfDaysOrWeeksRemaining?'visible':'hidden'">{{remainingDaysOrweeks}}</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="!validStore && game.gameStatus === GAMESTATUS[1]">
                    <div class="game-status-options bold-font-weight">
                        <button role="link" class="btn btn-xl btn-primary  game-status-text" #gameStatus (keyup.enter)="openDetails($event)"  [attr.aria-label]="'Change Stores To Keep Playing for ' + game.name ">Change Stores To Keep Playing</button>
                        <p class="pt-3" [style.visibility]="displayNumberOfDaysOrWeeksRemaining?'visible':'hidden'">{{remainingDaysOrweeks}}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="!validStore && game.gameStatus === GAMESTATUS[2]">
                    <div class="game-status-options bold-font-weight">
                        <button role="link" class="btn btn-xl btn-primary  game-status-text" #gameStatus (keyup.enter)="openDetails($event)"  [attr.aria-label]="'Change Stores To Redeem Prizes for' + game.name ">Change Stores To Redeem Prizes</button>
                        <p class="pt-3" [style.visibility]="displayNumberOfDaysOrWeeksRemaining?'visible':'hidden'">{{remainingDaysOrweeks}}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="validStore && game.gameStatus === GAMESTATUS[2]">
                    <div class="game-status-options bold-font-weight">
                        <button role="link" class="btn btn-xl btn-primary game-status-text" #gameStatus (keyup.enter)="openDetails($event)"  [attr.aria-label]="'Redeem Prizes for ' + game.name " >Redeem Prizes</button>
                        <p class="pt-3" [style.visibility]="displayNumberOfDaysOrWeeksRemaining?'visible':'hidden'">{{remainingDaysOrweeks}}</p>
                    </div>
                </ng-container>
                
            </ng-container>


        </div>
    </div>
   </div>
</div>
<ng-template *ngIf="isSingleCard" #howItWorks>
    <div class="episodic-header">
        <button [autofocus] type="button" class="close" id="how-it-works-close" data-dismiss="modal" aria-label="How It Works Close" tabindex="0" data-tabindex="first" (click)="closeHowItWorks()">
            <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
        </button>
    </div>
    
    <div class="episodic-body pl-4 pr-4" role="article">
        <div role="heading" id="how-it-works-title" aria-level="1" class="title-lg-bold episodic-body__title">
            How It Works
        </div>
        
        <!-- game details is in JSON format -->
        <ng-container *ngIf="gameDetails != null">
            <div class="episodic-body__howitworks-grid">
                <ng-container *ngFor="let detail of gameDetails">
                    <div class="episodic-body__howitworks-grid__row ml-3 mr-3 mt-4">
                        <div class="episodic-body__howitworks-grid__row__image">
                            <picture>
                                <source media="(min-width: {{md}})" [srcset]="detail.image_high">
                                <source media="(min-width: {{sm}})" [srcset]="detail.image_med">
                                <img loading="lazy" role="presentation" [src]="detail.image_default" alt=""/>
                            </picture>
                        </div>
                        <div class="episodic-body__howitworks-grid__row__text ml-3">
                            <div role="heading" aria-level="2" class="episodic-body__howitworks-grid__row__text__headline title-xs">
                                {{detail.headline}}
                            </div>
                            <div class="episodic-body__howitworks-grid__row__text__body-copy">
                                {{detail.copy}}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

        </ng-container>

        <!-- When game details is not in JSON format -->
        <div *ngIf="game.details != null && game.details != '' && gameDetails == null" [outerHTML]="game.details"></div>

    </div>
    <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
        <ng-container *ngIf="optinEnhancements">
            <button (click)="closeHowItWorks()" tabindex="0" class="btn btn-xl btn-primary body-text episodic-footer__button">{{howItWorksExistingUser}}</button>
        </ng-container>
        <ng-container *ngIf="!optinEnhancements">
            <button *ngIf="!optInStatus && !game.disableGamePlay" (click)="showOptIn()" tabindex="0" class="btn btn-xl btn-primary body-text episodic-footer__button">{{howItWorksNewUser}}</button>
            <button *ngIf="optInStatus || game.disableGamePlay" (click)="closeHowItWorks()" tabindex="0" class="btn btn-xl btn-primary body-text episodic-footer__button">{{howItWorksExistingUser}}</button>
        </ng-container>
        <div>
            <ng-container *ngIf="game.type == GAMETYPES.EPISODIC">
                <a href="{{programRulesLink}}" target="_blank" role="link" tabindex="0" (click)="analyticsModalTracking('how-it-works|official-rules','click')" aria-label="Official Rules link opens in a new tab" class="links__action links__action__inline underline">Official Rules</a>
                <span class="pl-3 pr-3 color-neutral-300">|</span>
                <a href="{{programFAQLink}}" target="_blank" role="link" tabindex="0" class="links__action links__action__inline underline" aria-label="FAQ link opens in a new tab" data-tabindex="last">FAQ</a>
            </ng-container>
            <ng-container *ngIf="(game.type == GAMETYPES.DIVISION && !optinEnhancements)">
                <a href="{{programRulesLink}}" target="_blank" role="link" tabindex="0" (click)="analyticsModalTracking('how-it-works|official-rules','click')" aria-label="Official Rules link opens in a new tab" class="links__action links__action__inline underline" data-tabindex="last">Official Rules</a>
            </ng-container>
        </div>
    </div>
</ng-template>
    